import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image
} from "react-native";
import {moderateScale} from '../../../tools/Scaling';

const SLIDER_1_FIRST_ITEM = 1;
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import HMTextView from "../../../customviews/HMTextView";
import Colors from "../../../tools/Colors";
import store from "../../../redux/store";
import {connect} from "react-redux";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import HMIcon from "../../../customviews/HMIcon";
import {serviceActionSetNameDynamic} from "../../137/splash/action/ActionSplashGetAllData";
import HMFlatList from "../../../customviews/HMFlatList";
import {Tools} from "../../../tools/Tools";
import axios from "axios";
import {typeExport} from "../../../redux/store/type";
import HMAlert from "../../../customviews/HMAlert";
import i18n from '../../../I18n/i18n.js';
import Toast from "../../../customviews/toast";
import HMButton from "../../../customviews/HMButton";
import * as NavigationService from "../../../redux/NavigationService";
import HMImageView from "../../../customviews/HMImageView";
import HMTextInput from "../../../customviews/HMTextInput";

let container = null;

class ListCityScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let {DataSplashScreen} = this.props;
        let selectCity = DataSplashScreen?.City?.id;
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            selectCity: selectCity,
            // list: [],
            //   list: props.route && props.route.params && props.route.params.list ? props.route.params.list : (this.props.user && this.props.user.customers ? this.props.user.customers : []),
            /*       list: [
                       {
                           id: 1,
                           name: 'اراک',
                           Type: 'Wireless',

                       },
                       {
                           id: 2,
                           name: 'شازند',
                           Type: 'Wireless',

                       },
                       {
                           id: 3,
                           name: 'آستانه',
                           Type: 'Wireless',

                       },
                       {
                           id: 4,
                           name: 'خمین',
                           Type: 'TD-LTE',

                       },
                       {
                           id: 5,
                           name: 'زرندیه',
                           Type: 'TD-LTE',

                       },
                       {
                           id: 6,
                           name: 'ساوه',
                           Type: 'TD-LTE',

                       },
                       {
                           id: 7,
                           name: 'فراهان',
                           Type: 'ADSL',

                       },


                   ],*/
            list: [],
            listSearch: [],
            listFilter: []
        };

        // props.callServiceRefresh();


    }

    async componentDidMount() {
        let user = this.props.DataSplashScreen?.user;
        let typeOrgan = this.props?.route?.params?.type;

        if (user && user.orgs && typeOrgan) {
            this.setState({
                list: user.orgs,
                listSearch: user.orgs,
            }, () => {
            })
        } else {
            this.getLocation();
            this.getListCity();
        }
        // let {list} = this.state
        // if (!(list && list.length > 0)) {
        //     Tools.remove();
        // }
        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        //this.getData()

    }


    /*  getData() {

          this.setState({
              //ShowImage:true
              isLoading: true,
              NoInternetDialog: false,

          })


          const formData = new FormData();
          formData.append('lang', i18n.locale);
          formData.append('token', this.props.token);


          const config = {
              headers: {
                  "Content-Type": "multipart/form-data; charset=utf-8;",
                  // 'Content-Type': 'application/json',
                  // "Authorization": `Basic ${params.token}`,
                  timeout: Constants._TIMEOUT_FILE
              }
          };

          axios.post(typeExport._baseUrlSatia + "services/customerGigs", formData, config)
              .then(async response => {
                  let data = response.data;
                  let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                  // data.status ? this.state.listImage.push(image) : null;

                  this.setState({
                      //ShowImage:true
                      list: data.status ? list : this.state.list,
                      //TypeDocumentsList:[],
                      isLoading: false,
                      NoInternetDialog: !data.status,

                  })
              }).catch((e) => {

              this.setState({
                  //ShowImage:true
                  isLoading: false,
                  NoInternetDialog: true,

              })
          })
      }*/

    render() {
        let typeOrgan = this.props?.route?.params?.type;
        let {DataSplashScreen} = this.props;
        let {nowCity} = this.state;
        let user = this.props.DataSplashScreen?.user;
        let {OrganCity, City} = this.props.DataSplashScreen;
        //let orgs = user?.orgs;

        let selectCity = typeOrgan ? DataSplashScreen?.OrganCity?.id : DataSplashScreen?.City?.id;
        selectCity = selectCity ? selectCity : this.state.selectCity?.id;
        //let item = this.props.route.params ? this.props.route.params.item : null


        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu={false}
                            back={true}
                            props={this.props} statusBarTransparent
                            text={typeOrgan ? "انتخاب حوزه نظارتی" : "انتخاب شهر"}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : "اشتراک ها"}
                            //   text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />


                        <View style={{flex: 1}}>


                            <View style={{flex: 1}}>


                                <HMTextInput
                                    //voice
                                    value={this.state.textInputSearch}
                                    //keyboardType="numeric"
                                    onChangeText={(text) => this.setState({textInputSearch: text}, () => {
                                        this.SearchFilterFunction(this.state.list, text)

                                    })}
                                    // autoFocus
                                    placeholder={"شهر مورد نظر را " + i18n.t('constant.Search') + " نمایید "}
                                    NoShowPlaceholder

                                    style={{
                                        fontSize: moderateScale(14),
                                    }} underlineColorAndroid="transparent"
                                    styleRoot={{
                                        width: "99%",
                                        alignSelf: "center",
                                        backgroundColor: Colors.white,
                                        padding: moderateScale(8),
                                        marginTop: moderateScale(8),
                                        borderRadius: moderateScale(6)
                                    }}
                                />


                                <HMFlatList
                                    style={{
                                        // alignSelf: 'center',
                                        marginTop: moderateScale(6)
                                    }}
                                    // ItemSeparatorComponent={
                                    //     <View style={{
                                    //         width: '100%',
                                    //         height: moderateScale(1),
                                    //         backgroundColor: '#4f4f4f'
                                    //     }}/>
                                    // }
                                    // data={comment === null || !comment ? [] : comment}
                                    //     numColumns={1}
                                    //type => 1=  , 2= , 3= , 4= ,
                                    ///data={this.props.DataSplashScreen.results.listGig}
                                    data={this.state.textInputSearch?.length > 0 ? this.state.listSearch : this.state.list}
                                    renderItem={({item, index}) => {

                                        //  let Account = this.props.DataSplashScreen.Account                                            // let CheckAccount = Account ? (Account.Serial === item.Serial) : (index === 0);
                                        //    let CheckAccount = Account ? Account.Serial && item.Serial && (Account.Serial === item.Serial) : false;
                                        let CheckAccount = false;
                                        return <TouchableOpacity
                                            disabled={CheckAccount}
                                            onPress={async () => {
                                                //    store.dispatch(serviceActionSuccess(null));

                                                store.dispatch(serviceActionSetNameDynamic(typeOrgan ? "OrganCity" : "City", item
                                                ));


                                                await AsyngStorageClass.setAsyng(typeOrgan ? "OrganCity" : "City", item);
                                                //NavigationService.resetTo("SplashScreen");
                                                NavigationService.BackTo(1);


                                                // try {
                                                //     NavigationService.resetTo('SplashSatiaScreen')
                                                //
                                                // } catch (e) {
                                                //     NavigationService.navigatereset('SplashSatiaScreen')
                                                //
                                                // }
                                            }}
                                            style={{
                                                // width: "100%",

                                                //  width: '100%',
                                                flex: 1,
                                                marginHorizontal: moderateScale(4),

                                                marginBottom: moderateScale(4),
                                                borderRadius: moderateScale(6),
                                                borderColor: CheckAccount ? Colors.green : '#d0d8df',
                                                backgroundColor: Colors.white,
                                                borderWidth: moderateScale(1),
                                                overflow: 'hidden',
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>

                                            <View
                                                style={{
                                                    width: "100%",
                                                    height: moderateScale(54),

                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    flexDirection: 'row',
                                                }}>


                                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                                    {
                                                        selectCity === item.id ?
                                                            <HMIcon
                                                                type={"AntDesign"}
                                                                name={"check"}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    //alignSelf: 'flex-end',
                                                                    color: Colors.green,
                                                                    // width: moderateScale(32),
                                                                    // height: moderateScale(32),
                                                                    fontSize: moderateScale(22)
                                                                }}/>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        item.svg || item.image ?

                                                            item.svg ?

                                                                <HMIcon

                                                                    //source={require('../../../../../assets/img/success.png')}
                                                                    //source={PathFile.image.background}
                                                                    //svg={PathFile.svg.add}
                                                                    type={"svg"}
                                                                    uri={item.svg}
                                                                    height={moderateScale(48)}
                                                                    width={moderateScale(48)}

                                                                    name={"add-circle-sharp"}
                                                                    style={{
                                                                        // fontSize: moderateScale(20),
                                                                        // color: Colors.blue,
                                                                        // marginHorizontal: moderateScale(4),
                                                                        marginRight: moderateScale(4),
                                                                        marginLeft: moderateScale(4),
                                                                        //  marginTop: moderateScale(3)
                                                                    }}
                                                                    styleRoot={{
                                                                        width: moderateScale(48),
                                                                        height: moderateScale(48),
                                                                        borderRadius: moderateScale(24),
                                                                        borderWidth: moderateScale(12),
                                                                        borderColor: Colors.gray,
                                                                        overflow: "hidden",
                                                                        marginHorizontal: moderateScale(4)
                                                                    }}
                                                                />
                                                                :
                                                                <View
                                                                    style={{
                                                                        width: moderateScale(48),
                                                                        height: moderateScale(48),
                                                                        borderRadius: moderateScale(24),
                                                                        borderWidth: moderateScale(2),
                                                                        borderColor: Colors.gray,
                                                                        overflow: "hidden",
                                                                        marginHorizontal: moderateScale(4),
                                                                    }}
                                                                >
                                                                    {
                                                                        item.image_source ?

                                                                            <HMImageView
                                                                                // resizeMode={FastImage.resizeMode.contain}
                                                                                resizeMode={"contain"}
                                                                                _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}
                                                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                // uriComplete={item.image}
                                                                                source_image={item.image_source}
                                                                                //  styleText={{marginTop: moderateScale(10)}}
                                                                                //  borderRadius={4}

                                                                            />
                                                                            :
                                                                            <HMImageView
                                                                                // resizeMode={FastImage.resizeMode.contain}
                                                                                resizeMode={"contain"}
                                                                                _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                //  uriComplete={"https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Circle-icons-flower.svg/1024px-Circle-icons-flower.svg.png"}
                                                                                source_image={item.image}
                                                                                //  styleText={{marginTop: moderateScale(10)}}
                                                                                // borderRadius={4}

                                                                            />
                                                                    }
                                                                </View>

                                                            :
                                                            null
                                                    }
                                                    <HMTextView
                                                        // numberOfLines={2}
                                                        type={"bold"}
                                                        text={item.name}
                                                        style={{
                                                            fontSize: moderateScale(14),

                                                            color: Colors.blackLight,
                                                            //  marginTop: moderateScale(4),
                                                            //  textAlign: "right",
                                                            //   textAlign: "center",
                                                            marginVertical: moderateScale(4),
                                                            marginHorizontal: moderateScale(3),

                                                        }}/>
                                                    {
                                                        nowCity && nowCity.id === item.id ?
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={" (شهر فعلی شما) "}
                                                                style={{
                                                                    fontSize: moderateScale(12),

                                                                    color: Colors.blue,
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                    //   textAlign: "center",
                                                                    marginVertical: moderateScale(4),
                                                                    marginHorizontal: moderateScale(12),

                                                                }}/>
                                                            :
                                                            null
                                                    }


                                                </View>
                                                {/*     <HMIcon
                                                        type={"AntDesign"}
                                                        name={I18nManager.getConstants().isRTL ? "left" : 'ios-arrow-forward'}
                                                        style={{
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.gray,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(22)
                                                        }}/>*/}
                                            </View>


                                        </TouchableOpacity>
                                    }}

                                    numColumns={3}

                                />


                            </View>

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.state.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getListCity()}/> : null
                            }
                        </View>
                        {/*     <HMButton text={"تایید"} style={{marginVertical: moderateScale(10)}} onPress={async () => {


                            if (typeOrgan ? OrganCity : City) {

                                await AsyngStorageClass.setAsyng(typeOrgan ? "OrganCity" : "City", typeOrgan ? OrganCity : City);
                                //NavigationService.resetTo("SplashScreen");
                                NavigationService.Pop();

                            }

                        }}/>*/}
                    </KeyboardAvoidingView>
                </View>


            </View>
        );
    }

    SearchFilterFunction(data, text) {


        const newData = data.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.subjects_tks_subject.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })

        this.setState({
                listSearch: text && text.length > 0 ? newData : [],

            },
            () => {

            })
    }

    getLocation() {
        let my_possitiob = store.getState().reducerSplashGetAllData.Location;
        if (my_possitiob) {
            this.goScreen(null, null, my_possitiob);
            console.log("@@@##1", my_possitiob)
        }
        else {
            this.setState({isLoading: true,}, () => {
                console.log("@@@##2", my_possitiob)

                Tools.checkPermission(
                    "SubmitRequestScreen",
                    null,
                    null,
                    this.goScreen,
                    this.stateError
                )
            })
        }


    }


    goScreen(route, item, position) {
        container.setState({
            //ShowImage:true
            //isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })

        axios(
            {
                url: `https://api.neshan.org/v2/reverse?lat=${position.coords.latitude}&lng=${position.coords.longitude}`,
                method: "GET",
                headers: {
                    "Api-Key": "service.LuOT4aFuRkaVSDsE8WLNkgyhUtsRZ2UnG4mpBEQt",
                    //'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                    "Content-Type": "application/json",
                },
                timeout: typeExport._TIMEOUT,
            }
        ).then(async response => {

            const city = response.data.city ? response.data.city : null;
            const result = container.state.list.find(obj => obj.name == city);
            console.log("@@@##response", city, result, response);

            // await AsyngStorageClass.setAsyng("City", {
            //     ...result,
            //     latitude: position.coords.latitude,
            //     longitude: position.coords.longitude
            // });
            // store.dispatch(serviceActionSetNameDynamic("City", {
            //     ...result,
            //     latitude: position.coords.latitude,
            //     longitude: position.coords.longitude
            // }));
            container.setState({
                nowCity: {
                    ...result,
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                },
                loadingAddressMarker: false,
            })

        }).catch((e) => {
            container.setState({loadingSearchMap: false, letAddressMarker: false, loadingAddressMarker: false,})
            console.log("error", e);
        })
        // let formData = new FormData();
        // formData.append('_operation', typeExport._Shahrdar);
        // formData.append('mode', "GetPlace");
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.DataSplashScreen.token);
        //  container.requestServer(position);
        // long: position && position.coords ? position.coords.longitude : (my_position ? my_position.coords.longitude : longitude),
        //     lat: position && position.coords ? position.coords.latitude : (my_position ? my_position.coords.latitude : latitude),
        // let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        //
        // container.setState({isLoading: false})
        // NavigationService.navigateParams(route, {
        //     position: JSON.stringify(Tools.cloneAsObject(position)),
        //     //   position: JSON.stringify(position),
        //     //  position:position,
        //     typeComponent: checkLogin ? "Operation" : null,
        //     item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
        //     data: JSON.stringify(item),
        //     type: route
        // })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }


    getListCity(func) {

        let item = this.props?.route?.params?.item;

        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetCities");

        //formData.append('name', this.state.namePattern);
        // formData.append('ids[]', []);
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.DataSplashScreen?.token);
        formData.append('tokenLaravel', this.props.DataSplashScreen?.tokenLaravel);
        //  formData.append('record', itemParams.RequestID);

        if (item && item.id) {
            formData.append('with_places', 1);
            formData.append('with_widgets', 1);

            // let arr = [];
            // arr.push(item.id)
            // formData.append('ids[]', arr);
        }
        this.requestServer(
            formData, (item) => {

                this.setState({

                    results: item,
                    list: item?.cities,
                    listSearch: item?.cities,
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {

                    //alert(item.success)
                    //func ? func() : null
                })
            }, false
        );
    }

    requestServer(formData, func, noLoading) {


        container.setState({
                //ShowImage:true
                isLoading: !noLoading,
                NoInternetDialog: false,
                // results: null
            },
            () => {
            })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);

        console.log("@#@#@", formData, func, noLoading)
        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    // global.G_DataDashboard = true;
                    // NavigationService.Pop();
                    func ? func(data.result) : null;

                    // container.getDataServerSplash()
                }
                else {
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'custom_info',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: data.message ? data.message : "سرور با مشکل مواجه شد مجددا تلاش نمایید",
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }


}

const mapStateToProps = state => {
    return {

        user: state.reducerSplashSatiaScreen.user,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
        DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ListCityScreen);
